export default "__VITE_ASSET__305faf98__"